import { FunctionComponent } from "react";
import { DropdownOptions } from "./types";
import "./styles.scss";
import classNames from "classnames";
const DropdownOptions: FunctionComponent<DropdownOptions> = (props) => {
  const { openDropdown, children, wrapperClass } = props;
  const wrapperClasses = classNames(
    "dropdown-list mt-1 ba-1 br-8",
    wrapperClass
  );

  return openDropdown ? (
    <>
      <div className={wrapperClasses}>{children}</div>
    </>
  ) : null;
};

export default DropdownOptions;
